import React from "react";

import { StatsCategoryRevenueDto } from "services/stats/restModels";
import { localizedText } from "shared/lib/localizedMap";
import { DataTable, DataTableColumn } from "shared/ui";

import { PercentBar } from "features/Statistics/components/PercentBar";
import { useStatisticsContext } from "features/Statistics/context";
import { share } from "features/Statistics/lib/share";

export const TopCategoriesTable = () => {
    const { categories, summary, locale, formatPrice } = useStatisticsContext();

    const totalRevenue = summary?.current.revenue?.price || 0;
    const totalOrders = summary?.current.ordersCount || 0;

    const columns: DataTableColumn<StatsCategoryRevenueDto>[] = [
        {
            key: "name",
            role: "primary",
            title: "Категория",
            render: (row) => localizedText(row.name, locale) || "Без названия",
        },
        {
            key: "revenue",
            role: "secondary",
            title: "Выручка / заказы",
            width: 180,
            render: (row) => `${formatPrice(row.revenue)} / ${row.ordersCount}`,
        },
        {
            key: "revenueShare",
            role: "secondary",
            title: "% от выручки",
            width: 200,
            render: (row) => <PercentBar percent={share(row.revenue.price, totalRevenue)} />,
        },
        {
            key: "ordersShare",
            role: "secondary",
            title: "% от заказов",
            width: 200,
            render: (row) => <PercentBar percent={share(row.ordersCount, totalOrders)} />,
        },
    ];

    return (
        <DataTable
            columns={columns}
            rows={categories}
            rowKey={(row) => row.menuCategoryId}
        />
    );
};
